import './index.scss';
import DisciplinesSubjectsSelect from 'utils/disciplines_subjects_select';
import { handleApiError } from 'utils/api_error_handler';

class QuestionMaintenanceTab {
  constructor($context) {
    this.$context = $context;
    this.$form = $('form', this.$context).ajaxForm();
    const $disciplineSelect = $('#discipline_ids', this.$form);
    const $subjectSelect = $('#subject_id', this.$form);

    DisciplinesSubjectsSelect.init($disciplineSelect, $subjectSelect, {
      enableVisualTree: true
    });

    vendorManager.ensure('quill', () => {
      this.instantiateQuill();
    });

    this.bind();
  }

  instantiateQuill() {
    const $questionId = $(
      '.q-maintence-quill-container',
      this.$context
    )[0].getAttribute('data-question-id');
    const quillContainer = $(`#description-${$questionId}`, this.$context)[0];

    const verifyQuillExistence =
      $(`#question-belt-${$questionId}-maintenance-tab`).find('.ql-toolbar')
        .length !== 0;

    if (verifyQuillExistence) {
      return;
    }

    if (quillContainer) {
      this.uploadBucket = quillContainer.getAttribute('data-upload-bucket');
      this.uploadUrl = quillContainer.getAttribute('data-upload-url');

      this.editor = new Quill(quillContainer, {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ color: [true, 'red', 'green', 'blue'] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['image']
          ]
        },
        placeholder: 'Escreva o seu comentário',
        theme: 'snow'
      });

      this.editor.getModule('toolbar').addHandler('image', () => {
        this._quillSelectLocalImage();
      });
    }
  }

  _quillSelectLocalImage() {
    const self = this;
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];

      if (/^image\//.test(file.type)) {
        await self._quillAddImage(file);
      } else {
        toastr.error('Ops! Você só pode enviar imagens');
      }
    };
  }

  async _quillAddImage(file) {
    const self = this;
    const randomId = new Date().getTime();
    const fileExtension = file.name.split('.').pop();
    const fileName = `odin/question_maintenance/${randomId}.${fileExtension}`;
    const fileUrl = `https://s3.amazonaws.com/${this.uploadBucket}/${fileName}`;

    await this.uploadToS3(file, fileName, fileExtension);

    self._quillInsertToEditor(fileUrl);
  }

  _quillInsertToEditor(url) {
    const range = this.editor.getSelection();
    this.editor.insertEmbed(range.index, 'image', url);
  }

  async getPresignedPostData(key, contentType) {
    return await $.ajax({
      url: this.uploadUrl,
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify({
        bucket: this.uploadBucket,
        key: key,
        content_type: 'docx',
        acl: 'public-read'
      })
    });
  }

  async uploadToS3(file, key, contentType) {
    const presignedPostData = await this.getPresignedPostData(key, contentType);
    const formData = new FormData();
    Object.keys(presignedPostData.fields).forEach(key => {
      formData.append(key, presignedPostData.fields[key]);
    });

    formData.append('file', file);

    await $.ajax({
      url: presignedPostData.url,
      type: 'POST',
      data: formData,
      cache: false,
      processData: false,
      contentType: false
    });
  }

  async submit() {
    try {
      const data = this.$form.serializeObject();

      if (this.editor) {
        data.comment = this.editor.root.innerHTML;
      }

      if (!data.subject_id && !data.comment) {
        return;
      }

      this.$form.addClass('q-loading');

      await Thor.QuestionMaintenances.create({}, { data });

      toastr.success('Operação realizada com sucesso!');
      this.$form.clearForm();
      this.$form.removeClass('q-loading');
    } catch (ex) {
      this.$form.removeClass('q-loading');
      handleApiError(null, ex.response || ex);
    }
  }

  bind() {
    this.$form.on('submit', e => {
      e.preventDefault();
      this.submit();
    });
  }
}

(function () {
  'use strict';

  $(document).on(
    'componentLoaded:questions/question_maintenance',
    (e, data) => {
      new QuestionMaintenanceTab(data.context);
    }
  );
})(jQuery);
